<template>
  <div class="bodovi">
    <v-container>
      <v-row class="text-center flex-column margin-center">
        <v-col>
        <router-link to="/" style="text-decoration:none;">
          <v-img
          :src="require('../assets/logo.svg')"
          class="my-3 mb-3 mt-3"
        />
        <p class="subheading text-left font-weight-medium pt-5 pb-5">
         Ovo su bodovi koje ste skupili kupovinom auto-delova brendova febi, SWAG i Blue Print. 
         Svakog meseca, bodovi će biti dodavani na vaš nalog na ovoj platformi, a onda tokom oktobra 2026. skupljene bodove možete zameniti za VISA poklon karticu sa određenim iznosom novca. 
        </p>

        <v-spacer></v-spacer>
        <p><b>Za sva pitanja možete kontaktirati info centar putem email adrese: <a href="mailto:club@bilsteingroup.com">club@bilsteingroup.com</a></b></p>
        <v-spacer></v-spacer>
        </router-link>
          <table class="col pl-0 pr-0">
            <tr v-for="points in points" v-bind:key="points" class="d-flex flex-column mb-4">
              <td id="febi" class="text-font results-card mb-3"> <v-img
                  :src="require('../assets/febi-bilstein.svg')"
                  class="my-2 mr-10"
                  contain
                />{{points.febi}} </td>
              <td id="swag" class="text-font results-card mb-3"> <v-img
                  :src="require('../assets/swag.svg')"
                  class="my-2 mr-10"
                  contain
                />{{points.swag}}</td>
              <td id="blueprint" class="text-font results-card mb-3">   <v-img
                  :src="require('../assets/blueprint.svg')"
                  class="my-2 mr-10"
                  contain
                />{{points.blueprint}}</td>
                
              <td id="bonus" style="text-align:left" class="text-font results-card mb-3"> <v-img
                style="font-size:32px;">Ukupno bodova:</v-img> {{points.bonus}}</td>
              <!--  <td class="results-card-bottom mt-3"> <h2 class="bottom-text text-left text-font ">Ukupno bodova:</h2> 
              <span><v-content :value="false" class="results-text text-font " >{{ getTotal() }}</v-content></span> -->
              <!-- </td> -->
            </tr>
          </table>
          <!-- <v-img
          :src="require('../assets/visa card bg-iskoseno.png')"
           contain    
          style="margin:0 auto;"
          width="50%"
           /> -->
          <!-- <div class="p-none col-sm-6 col-md-12 col-12">
              <v-btn id="notEnough" width="-webkit-fill-available" small height="50" rounded color="primary" @click="updatePoints">PREUZMITE POKLON</v-btn>
          </div> -->
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase'
import {db,fb} from '../main'

export default {
  name: 'Results',
  data() {
    return {
        points: []
      }
    },
    methods:{
      readData() {
    
          const user = fb.auth().currentUser
          db.collection(`accounts`).doc(user.uid).collection('points').get().then((querySnapshot) => { if (!querySnapshot.empty) {
           querySnapshot.forEach((doc) => {
                this.points.push(doc.data())
              })
            }
            else  {
               db.collection(`accounts`).doc(user.uid).collection('points').doc("1").set({
                    blueprint: 0,
                    swag: 0,
                    febi: 0,
                    bonus: 0
                })
              if(!window.location.hash) {
                  window.location = window.location + '#loaded';
                  window.location.reload();
              }
            }
          })
  

          
        },

        getTotal() {
          const totalPoints = this.points.reduce((acc, cur) => acc + Number(cur.febi+cur.blueprint+cur.swag+cur.bonus), 0)
          // if (totalPoints >= 0) {
          //     document.getElementById('notEnough').style.display = "none";
          // }
          // if (totalPoints >= 2000) {
          //    document.getElementById('notEnough').style.display = "block";
          // }
          // if (totalPoints > 0) {
          //     document.getElementById('notEnough').classList.remove('v-btn--disabled')
          //     document.getElementById('notEnough').setAttribute('disabled','false')
          // }
          // if (totalPoints == 154) {
          //    document.getElementById('notEnough').classList.remove('v-btn--disabled')
          //    document.getElementById('notEnough').setAttribute('disabled','false')
          // }
        if (isNaN(totalPoints)) {
            return 0;
          }
          return totalPoints
        },

        updatePoints() {
            const user = fb.auth().currentUser
              db.collection('accounts').doc(user.uid).collection('points').doc('1').update({
              blueprint:0,
              swag:0,
              febi:0,
              bonus:0
              })
            this.$router.push('/poklon')
        },
    },

    computed: {

    },
    created() {
      this.readData()

    },

}

</script>


<style>
.v-btn--disabled {
  display: none!important;
}
  .results-card {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #A7ADB1;
    padding: 10px;
    width: 100%;
    font-size: 3rem !important;
    font-weight: 400;
    line-height: 3.125rem;
    letter-spacing: normal !important;
  }
  .results-card-bottom {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    width: 100%;
  }
  .results-card .v-responsive__sizer {
    padding-bottom: 10%!important;
  }
  .results-text {
    font-size: 3rem !important;
    font-weight: 400;
    line-height: 3.125rem;
    letter-spacing: normal !important;
  }
  @media only screen 
and (max-width : 740px) {
  .results-card .v-responsive__sizer {
    padding-bottom: 25%!important
  }
  .results-card-bottom,.results-card {
        padding: 5px;
  }
}
  .results-card .v-image__image {
    background-position: left!important;
  }
  td {
    color:#D11112;
  }
  .bottom-text {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
  }
</style>